module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTIwMHB0IiBoZWlnaHQ9IjEyMDBwdCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMTIwMCAxMjAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPHBhdGggZD0ibTMzNC42OSA0MzUuNzgtMzEuNTc0IDMxLjU3NCAyNjUuMzQgMjY1LjMxIDMxLjU0NyAzMS41NTEgMzEuNTUxLTMxLjU1MSAyNjUuMzQtMjY1LjMxLTMxLjU3NC0zMS41NzQtMjY1LjMxIDI2NS4zNHoiIGZpbGw9IiM2NzY3NjciLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/collapse.svg
// module id = 972
// module chunks = 33